'use strict'

export default {
    /**
     * Get a product from the API by it's SKU code
     * @param {string} sku
     */
    getInfo(email) {
        return new Promise((resolve, reject) => {
            axios({
                method: 'get',
                url: '/api/catalogue-info',
                headers: {
                    'Accept': 'application/json'
                },
                params: {
                    billing_email: email
                }
            })
            .then(response => {
                resolve(response.data);
            }).catch(errors => {
                reject(errors);
            });
        });
    },
}



// WEBPACK FOOTER //
// ./resources/assets/js/Services/Catalogue.js